export const ADD_ITEM = 'ADD_ITEM';
export const MERGE_ITEM = 'MERGE_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const ADD_ITEMS = 'ADD_ITEMS';
export const SET_ITEMS = 'SET_ITEMS';
export const SET_CART_NOTE = 'SET_CART_NOTE';
export const SET_PRODUCT_ID = 'SET_PRODUCT_ID';
export const SET_CAMPAIGN = 'SET_CAMPAIGN';
export const ADD_UPSELL = 'ADD_UPSELL';
export const REMOVE_UPSELL = 'REMOVE_UPSELL';

const fixItemPrice = item => {
    const { price, line_price, quantity, discounts } = item;
    if (!discounts?.length && line_price > 0 && price * quantity !== line_price) {
        item.price = line_price / quantity;
    }
    return item;
};

export const CartItemsReducer = AppLocalStorage => (state, action) => {
    switch (action.type) {
        case SET_ITEMS:
            const items = action.items.map(fixItemPrice);
            sendCartUpdatedEvent(items);
            return {
                ...state,
                items,
                cart_level_discount_applications:
                    action.cart_level_discount_applications ||
                    state.cart_level_discount_applications
            };
        case SET_CART_NOTE:
            return { ...state, cartNote: action.cartNote };
        case ADD_ITEM:
            const new_items = [action.item].concat(state.items).map(fixItemPrice);
            sendCartUpdatedEvent(new_items);
            return { ...state, items: new_items };
        case MERGE_ITEM:
            const item_exists = state.items.find(({ id }) => id === action.item.id);
            if (!item_exists) {
                const items = [action.item].concat(state.items).map(fixItemPrice);
                sendCartUpdatedEvent(items);
                return { ...state, items };
            } else {
                const items = state.items.map(item => {
                    if (item.id === action.item.id) {
                        return action.item;
                    }
                    return item;
                });
                sendCartUpdatedEvent(items);
                return { ...state, items };
            }
        case REMOVE_ITEM:
            const filtered_items = state.items.filter(({ id }) => id !== action.id);
            sendCartUpdatedEvent(filtered_items);
            return { ...state, items: filtered_items };
        case ADD_ITEMS:
            const added_items = action.item.concat(state.items).map(fixItemPrice);
            sendCartUpdatedEvent(added_items);
            return { ...state, items: added_items };
        case SET_PRODUCT_ID:
            return { ...state, product_id: action.product_id };
        case SET_CAMPAIGN:
            return { ...state, campaign: action.campaign };
        case ADD_UPSELL:
            const newUpsells = [...new Set([...state.fbtUpsells, action.id])];
            AppLocalStorage.setItem('monster_uc_upsells', JSON.stringify(newUpsells));
            return { ...state, fbtUpsells: newUpsells };
        case REMOVE_UPSELL:
            const finalUpsells = state.fbtUpsells.filter(variant_id => variant_id !== action.id);
            AppLocalStorage.setItem('monster_uc_upsells', JSON.stringify(finalUpsells));
            return { ...state, fbtUpsells: finalUpsells };
        default:
            return state;
    }
};

function sendCartUpdatedEvent(items) {
    const event = new CustomEvent('cart:updated', { detail: { items } });
    document.dispatchEvent(event);
}
